import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import { profile } from './profile/index';
import { dialog } from './dialog/index';
import { statistics } from './statistics/index'; //statistics -> index.ts 

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: '1.0.0'
  },
  modules: {
    profile,
    dialog,
    statistics
  }
};

export default new Vuex.Store<RootState>(store);
